import React, {forwardRef} from 'react';

const PostSubmissionScrollPoint = forwardRef<HTMLDivElement>((props, ref) => {
  return <div ref={ref} />;
});

export default PostSubmissionScrollPoint;
